export const frontmatter = {
    "draft": false,
    "title": "Knowledge Base",
    "sidebar_group": "reference",
    "sidebar_label": "Knowledge Base",
    "sidebar_order": 10
}

export const toc = []